var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('img',{style:({  'width': '20vw' ,'margin-bottom':'10px', 'border-radius': _vm.field.radius + 'px' }),attrs:{"src":_vm.field.url}})
}
var staticRenderFns = []

export { render, staticRenderFns }